export const useBoletoFormTranslate = translateIntl => {
    const t = key => translateIntl(`boleto.form.${key}`)
    const tLabel = key => t(`label.${key}`)

    return {
        t,
        tLabel,
    }
}
